import React, { useState } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import ModalWrapper from '../modals/ModalWrapper';
import ManageIslandsWizard from './manage-islands-wizard/Index';

import './ManageIslandsModal.scss';

import { Routes } from '../../routes';
import Env from '../../utils/env';
import { persistor } from '../../redux/store';

const { TEACHER_PORTAL } = Env;

interface Props {
  title?: string
}

const ManageIslandsModal = ({ title = 'Islands' }: Props): React.ReactElement => {
  const { id } = useParams() as { id: string };
  const [selectedIslandId, setSelectedIslandId] = useState(id);
  const history = useHistory();

  const onCancel = () => {
    history.push(Routes.Islands.Index);
  };

  const onConfirm = () => {
    if (selectedIslandId) {
      history.push(generatePath(Routes.Islands.View, {
        id: selectedIslandId,
      }));
    } else {
      history.push(generatePath(Routes.Islands.Index));
    }
  };

  const disableSelectIsland = !selectedIslandId;
  const onCloseFn = TEACHER_PORTAL ? undefined : onCancel;

  const logout = () => {
    persistor.purge();
    window.location.assign(generatePath(Routes.Session.New));
  };

  return (
    <ModalWrapper headerTitle={title} onClose={onCloseFn}>
      <div className="manage-island-modal">

        { /* On the teacher portal/"classroom mode" students need a way to log out, but users in non-classroom */ }
        { /* mode will log out via the navigation area in the top right-hand corner of the screen */ }
        { TEACHER_PORTAL
          && (
            <button className="button primary logout" type="button" onClick={logout}>
              Logout
            </button>
          ) }

        <div className="content">
          <ManageIslandsWizard
            selectedIslandId={selectedIslandId}
            onSelectIsland={setSelectedIslandId}
          />
        </div>

        <div className="actions">
          {!TEACHER_PORTAL && (
            <button
              className="button primary"
              type="button"
              onClick={onCloseFn}
            >
              Cancel
            </button>
          )}

          <button
            className="button primary"
            type="button"
            disabled={disableSelectIsland}
            onClick={onConfirm}
          >
            Ok
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ManageIslandsModal;
